export const isNumber = (value) => {
    return typeof value === "number" && !isNaN(value);
};
export const isNumberArray = (value) => {
    return Array.isArray(value) && value.every(isNumber);
};
//# sourceMappingURL=number-type-guards.js.map